module.exports = __webpack_public_path__ + "static/code-complete-cec731bbfcbbbb71364bb9616b2201ae.jpg";